export enum ForloebOverviewTypeEnum {
    ForloebOverblikBrugereView = 1,
    ForloebOverblikStillingerView = 2,
    ForloebOverblikKladdeView = 3,
}
